import { Stack, Typography } from "@mui/material";

import { createFieldList, getTextValue } from "./formHelpers";
import { Shared_FormTemplateFragment } from "./fragments/fragments.generated";

type Props = {
    form: Shared_FormTemplateFragment;
    values: Record<string, string | null> | null;
};

export default function FormTemplateValuesDisplay({ form, values }: Props) {
    const fields = createFieldList(form, values);

    return (
        <Stack rowGap={2}>
            {fields.map(q => (
                <Stack key={q.id}>
                    <Typography variant="caption">{q.name}</Typography>
                    <Typography>{getTextValue(values, q) ?? "—"}</Typography>
                </Stack>
            ))}
        </Stack>
    );
}
